<template>
  <div class="message-thread__reaction">
    <v-icon icon="favorite" />
  </div>
</template>

<script>
export default {
  props: {
    ts: { type: [Number, String], required: true }
  },

  methods: {
    selfDestruct() {
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    }
  },

  mounted() {
    setTimeout(() => this.selfDestruct(), 4000)
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";
@import "@/assets/styles/mixins";

.message-thread__reaction {
  position: absolute;
  bottom: 2rem;
  bottom: calc(2rem + env(safe-area-inset-bottom));
  right: 2rem;
  opacity: 0;
  animation: float-up 4s ease;
  pointer-events: none;

  .v-icon {
    color: #ff2e2b;
    transform: scale(1.5);
  }
}

@keyframes float-up {
  0% {
    transform: translateY(0vh) scale(1);
    opacity: 1;
  }

  5% {
    transform: translateY(-1vh) scale(1);
    opacity: 1;
  }

  15% {
    transform: translateY(-15vh) scale(1.4);
    opacity: 1;
  }

  100% {
    transform: translateY(-100vh) scale(0.8);
    opacity: 0;
  }
}
</style>
